import React, { useEffect } from 'react';
import Header from'../Component/Header'
import { Link } from 'react-router-dom';
const Examination = () => { 
    useEffect(() => {
        document.title = ' Examination - Sacread Heart Kharagpur';  
    }, []); 
  return (
     <>
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                  <li>Academic</li>
                 <li>Examination</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Examination</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                         <ul className="list">
                         <li> For classes V - VIII There are Two Examinations Half Yearly and Final and two Unit of Tests of 10 marks each in the whole year and project for 10 marks. Students are permitted to carry only the Admit Card, writing/drawing requisites into the examination hall. For class IX - XII there are 3 terms 1st, 2nd & final and unit test of 10 marks and project for 10 marks. </li>
                         <li> Communications of any sort or in any form is strictly forbidden between students and any other persons whether inside or outside the examination hall. </li>
                         <li> In particular cheating will be dealt with sternly. If a pupil is found using unfair means in an examination that particular paper will be cancelled and he shall be suspended from appearing for the rest of the papers and will be allotted zero in all the papers of the current examination. </li>
                         <li> If a pupil is found persisting in such unfair practices, T.C. will be issued without any further notification to those concerned. </li>
                         <li> A pupil who misses an examination/test/may not appeal for re-examination/re-test at a later date. </li>
                         
                         </ul>
                    </div>
                </div>
                 
            </div>
        </div>
     </>
  )
}

export default Examination

